<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div class="dialog-content-wrapper shippingmethodDialog" id="shippingmethod-wrapper">
  <mat-toolbar class="header m-0 fx-row">
    <mat-toolbar-row class="fx-row fx-main-between fx-cross-center fx-flex">
      <span class="title dialog-title fx-flex" translate=""> Edit Shipping Method</span>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content id="shippingmethod-content" class="fx-col">
    <div class="m-b-20 fx-row fx-main-center fx-cross-center">
      <span translate="choose_your_ship_method"></span>
    </div>
    @if (shipMethods && shipMethods.length>0) {
      @for (ship of shipMethods; track ship) {
        <div class="m-b-20 fx-row fx-flex-100-in-col">
          <div class="fx-flex-100">
            <mat-radio-group aria-label="Select an option" class="fx-col"
              [(ngModel)]="selectedShippingMethod">
              <mat-radio-button class="fx-row-in-radio" [value]="ship.ShipMethodId"
                >
                <div class="fx-row fx-flex-100">
                  <div class="fx-flex-80">
                    <span [textContent]="ship.Description"></span>
                  </div>
                  <div class="fx-row fx-main-start fx-cross-stretch fx-flex-20">
                    <span> <small class="text-muted"
                    [textContent]="ship.ShippingAmount | currency: companyService.selectedCurrency.CurrencyCode"></small></span>
                  </div>
                </div>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      }
    }
  </div>
  <div mat-dialog-actions class="m-0 p-16 fx-row fx-main-end fx-cross-center">
    <div>
      <button mat-raised-button class="updateButton" (click)="updateShipMethod()">
        {{'update' | translate}}
      </button>
    </div>
  </div>
</div>